module.exports = __webpack_public_path__ + "static/img/m_name.f15b5ff.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/mobile_img/role3/mx/m_name.png
// module id = P+Ol
// module chunks = 7